export const SCREENS = {
  sm: 0,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
};

export const BREAKPOINTS = [
  {
    label: 'Mobile',
    name: 'mobile',
    width: SCREENS.md / 2,
    height: 667,
  },
  {
    label: 'Tablet',
    name: 'tablet',
    width: SCREENS.md + (SCREENS.lg - SCREENS.md) / 2,
    height: 1024,
  },
  {
    label: 'Desktop',
    name: 'desktop',
    width: SCREENS.lg + (SCREENS.xl - SCREENS.lg) / 2,
    height: 900,
  },
];

export const TO_TOP_SCROLL_THRESHOLD = 300;
export const SKIP_TO_CONTENT_ID = 'sisu';
export const NAV_CONTENT_ID = 'nav-content';

export const POWER_BI_DOMAIN = 'https://app.powerbi.com/';

export * from './metrics';
export * from './pages';
export * from './roles';
export * from './search';
export * from './status';
